<p-accordion
  id="accordion"
  [multiple]="false"
  (onOpen)="abrirAcordeon($event.index)"
>
  <p-accordionTab header="{{ titulo }}" [selected]="tabSeleccionado === 'PASO'">
    <app-flujo-venta-tab-view
      [tabView]="tabView"
      [listaSecuencias]="listaSecuencias"
      [listaVinculaciones]="listaVinculaciones"
      [lisPasos]="lisPasos"
      [secFija]="false"
      [showControlesTable]="true"
      [listaTiposPersonas]="listaTiposPersonas"
      [HabilitarindicadorVinculacionPorPerfil]="true"
    >
    </app-flujo-venta-tab-view>
  </p-accordionTab>

  <!-- TAB Restricciones Perfil por Vinculación -->
  <p-accordionTab
    header="{{
      'FLUJOVENTARESTRICCIONESPERFILXVINCULACION.LBL_FLUJOVENTARESTRICCIONESPERFILXVINCULACION'
        | translate
    }}"
    [selected]="tabSeleccionado === 'RESPERXVIN'"
    [disabled]="!tabView.flujoVenta?.idFlujoVentaPaso"
    *ngIf="tabView.flujoVenta?.indicadorVinculacionPerfil"
  >
  <app-fv-restricciones-perfil-x-vinculacion [tabView]="tabView"></app-fv-restricciones-perfil-x-vinculacion>
  </p-accordionTab>
</p-accordion>
